import { all, call, put, takeLatest } from 'redux-saga/effects';

import workspaceService from '@app/libs/workspaceService';
import { BULK_REQUEST_REQUEST_TASKS_STATUS__FETCH_REQUEST } from '@app/store/actionTypes';
import {
  fetchRequestTasksStatus,
  fetchRequestTasksStatusFailure,
  fetchRequestTasksStatusSuccess,
} from '@app/store/bulkRequest/requestTasks/status/actions';
import { getRequestTasksAllStatus } from '@app/store/transport-layer/bulk-request/bulk-requests/request-tasks/all/status';

export function* fetchRequestTasksStatusSaga({
  payload,
}: ReturnType<typeof fetchRequestTasksStatus>) {
  try {
    const status: Awaited<ReturnType<typeof getRequestTasksAllStatus>> = yield call(
      getRequestTasksAllStatus,
      workspaceService.getWorkspaceId(),
      payload
    );
    yield put(fetchRequestTasksStatusSuccess(status));
  } catch (error) {
    yield put(fetchRequestTasksStatusFailure(error));
  }
}

export default function* sagas() {
  yield all([
    takeLatest(BULK_REQUEST_REQUEST_TASKS_STATUS__FETCH_REQUEST, fetchRequestTasksStatusSaga),
  ]);
}
